module.exports = __webpack_public_path__ + "media/images/vacancy_subscription_success-e5bf3887.png";